export const ORDER = 'Order';
export const CLASSIFY = 'Classify';
export const PARSONS = 'Parsons';
export const EXPORTED_KINDS = [ORDER, CLASSIFY, PARSONS];